import { State } from '@/modules/conservatorship/types';

export const isClosed = (state: State | null) => ['closed', 'archived'].includes(state || '');

export const isArchived = (state: State | null) => ['archived'].includes(state || '');

export const isChangeable = (state: State | null) => false === isArchived(state);

export const includesScopeOfFunctions = (scopeOfFunctions: string, scopesOfFunctions: string[]) => !scopeOfFunctions || scopesOfFunctions.includes(scopeOfFunctions);
